import Info10Content from '../components/info/Info10PageContent';

const Info10Page = () => {
  return <Info10Content />;
};

export default Info10Page;